import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemBalloons = function IconSystemBalloons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.815 15.07S9.5 16.5 10.5 18c.901 1.352 0 3.5 0 3.5m3.975-7.685s.886 1.588.025 3.685c-.5 1.218 0 4.5 0 4.5M11.845 9.825c0 2.66-.66 5.496-3.22 5.496-2.328 0-6.698-3.601-6.624-6.761.068-2.913 2.491-4.645 5.052-4.645s4.792 3.25 4.792 5.91m7.65 2.143c-2.001 1.614-4.635 2.941-6.19 1.015-1.412-1.752-1.354-7.225 1.069-9.087 2.232-1.716 5.162-.945 6.716.982s.406 5.476-1.595 7.09"
  }));
};